
import { EndpointScenarioMap } from './mock.types';

export interface JvPartnerConfig {
  partnerId: string;
  displayName: string;
  primaryColor: string;
  logoUrl: string;
  contactPhone: string;
  productionDomains: string[];
}

export const JV_PARTNERS: Record<string, JvPartnerConfig> = {
  brphm: {
    partnerId: 'brphm',
    displayName: 'BRP Home Mortgage',
    primaryColor: '#00467f',
    logoUrl: '/assets/brands/brp/img/header_logo.svg',
    contactPhone: '(888) 983-3717',
    productionDomains: ['brphomemortgage.com', 'www.brphomemortgage.com'],
  },
  hm: {
    partnerId: 'hm',
    displayName: 'Henlopen Mortgage',
    primaryColor: '#00203d',
    logoUrl: '/assets/brands/henlopen/img/header_logo.svg',
    contactPhone: '(888) 983-3717',
    productionDomains: ['henlopenmortgage.com', 'www.henlopenmortgage.com'],
  },
  hmllc: {
    partnerId: 'hmllc',
    displayName: 'Heartwood Mortgage LLC',
    primaryColor: '#9a5724',
    logoUrl: '/assets/brands/heartwood/img/hwm_logo.svg',
    contactPhone: '(877) 388-5352',
    productionDomains: ['heartwoodmortgage.com', 'www.heartwoodmortgage.com'],
  },
  lgims: {
    partnerId: 'lgims',
    displayName: 'LGI Mortgage Solutions',
    primaryColor: '#043345',
    logoUrl: '/assets/brands/lgims/img/lgi_logo.svg',
    contactPhone: '(888) 983-3717',
    productionDomains: ['lgimortgagesolutions.com', 'www.lgimortgagesolutions.com'],
  },
  mscm: {
    partnerId: 'mscm',
    displayName: 'MSC Mortgage',
    primaryColor: '#003155',
    logoUrl: '/assets/brands/msc/img/header_logo.svg',
    contactPhone: '(888) 983-3717',
    productionDomains: ['mscmortgage.com', 'www.mscmortgage.com'],
  },
  mthm: {
    partnerId: 'mthm',
    displayName: 'MTH Mortgage',
    primaryColor: '#1b5698',
    logoUrl: '/assets/brands/mth/img/header_logo.svg',
    contactPhone: '(888) 983-3717',
    productionDomains: ['mthmortgage.com', 'www.mthmortgage.com'],
  },
  nhcm: {
    partnerId: 'nhcm',
    displayName: 'NHC Mortgage',
    primaryColor: '#003366',
    logoUrl: '/assets/brands/nhc/img/nhc_logo.png',
    contactPhone: '(855) 329-3490',
    productionDomains: ['nhcmortgage.com', 'www.nhcmortgage.com'],
  },
  ridgeland: {
    partnerId: 'ridgeland',
    displayName: 'Ridgeland Mortgage',
    primaryColor: '#4d5a31',
    logoUrl: '/assets/brands/ridgeland/img/header_logo.svg',
    contactPhone: '(888) 983-3717',
    productionDomains: [],
  },
  sfl: {
    partnerId: 'sfl',
    displayName: 'SureFirst Lending',
    primaryColor: '#1B6333',
    logoUrl: '/assets/brands/surefirst/img/header_logo.svg',
    contactPhone: '(800) 287-6695',
    productionDomains: ['surefirstlending.com', 'www.surefirstlending.com'],
  },
};

export function getJvPartnerConfig(partnerId: string): JvPartnerConfig | undefined {
  return JV_PARTNERS[partnerId.toLowerCase()];
}

export function getAllJvPartnerIds(): string[] {
  return Object.keys(JV_PARTNERS);
}

export interface JvThemeDetectionResponse {
  isJvTheme: boolean;
  partnerId: string | null;
  partnerConfig: JvPartnerConfig | null;
}

export const jvThemeDetectionMock: EndpointScenarioMap<JvThemeDetectionResponse> = {
  'jv-mscm': {
    isJvTheme: true,
    partnerId: 'mscm',
    partnerConfig: JV_PARTNERS['mscm'],
  },
  'jv-hmllc': {
    isJvTheme: true,
    partnerId: 'hmllc',
    partnerConfig: JV_PARTNERS['hmllc'],
  },
  'no-jv': {
    isJvTheme: false,
    partnerId: null,
    partnerConfig: null,
  },
  default: {
    isJvTheme: false,
    partnerId: null,
    partnerConfig: null,
  },
};

export const jvOriginationApplicationMock: EndpointScenarioMap<
  {
    id: string;
    propertyAddress: string;
    loanNumber: string;
    loanAmount: number;
    status: string;
    statusLabel: string;
    loanType: string;
  }[]
> = {
  'jv-single-application': [
    {
      id: 'jv-app-001',
      propertyAddress: '123 Partner Way, Costa Mesa, CA 92627',
      loanNumber: 'JV0012345678',
      loanAmount: 550000,
      status: 'PendingApproval',
      statusLabel: 'Application Pending',
      loanType: 'Purchase',
    },
  ],
  'jv-no-application': [],
  default: [
    {
      id: 'jv-app-001',
      propertyAddress: '123 Partner Way, Costa Mesa, CA 92627',
      loanNumber: 'JV0012345678',
      loanAmount: 550000,
      status: 'PendingApproval',
      statusLabel: 'Application Pending',
      loanType: 'Purchase',
    },
  ],
};
